import { buttoBaseStyle } from '@screens/lp-default/styles';
import styled, { css } from 'styled-components';

export const titleBaseStyle = css`
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  margin: 0;
  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    font-size: 24px;
  }
  @media only screen and (min-width: 1024px) {
    font-size: 28px;
  }
`;

export const Container = styled.section`
  align-items: center;
  background-color: ${({ theme }) => theme.elsie.colors.interactive.subtle.default};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.subtle};
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  position: relative;

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    padding: 0 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  z-index: 2;

  @media only screen and (max-width: 663px) {
    align-items: center;
    flex-direction: column;
    padding: 40px 20px;
  }

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    align-items: center;
    flex-direction: column;
    padding: 40px 24px;
  }
  @media only screen and (min-width: 1024px) {
    flex-direction: row;
    height: 208px;
    justify-content: space-between;
    padding: 32px 64px;
  }
`;

export const Background = styled.picture`
  position: absolute;
  right: 0;
  bottom: -5px;
  z-index: 1;

  @media only screen and (min-width: 1024px) and (max-width: 1319px) {
    margin-right: -270px;
  }
`;

export const Title = styled.h1`
  ${titleBaseStyle};
`;

export const Price = styled.h3`
  ${titleBaseStyle};
`;

export const Text = styled.span`
  font-size: 15px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0;
`;

export const DescriptionWrapper = styled.div`
  display: flex;

  @media only screen and (max-width: 663px) {
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;

    & > h1 {
      text-align: center;
    }
  }

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;

    & > h1 {
      text-align: center;
    }
  }
  @media only screen and (min-width: 1024px) {
    width: 372px;
  }
`;

export const PricesWrapper = styled.div`
  align-items: center;
  display: flex;

  @media only screen and (max-width: 663px) {
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;
  }

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;
  }

  @media only screen and (min-width: 1024px) and (max-width: 1319px) {
    flex-direction: column;
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;
  }

  @media only screen and (min-width: 1024px) {
    width: 430px;
  }
`;

export const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;

  @media only screen and (max-width: 663px) {
    flex-direction: column-reverse;
    gap: 12px;
    width: 100%;
  }

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    flex-direction: column-reverse;
    gap: 12px;
    width: 100%;
  }

  @media only screen and (min-width: 1024px) {
    gap: 16px;
  }
`;

export const MonthlyPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 33px;

  @media only screen and (max-width: 663px) {
    border-bottom: 1px solid ${({ theme }) => theme.elsie.colors.others.divider};
    padding-bottom: 8px;
    padding-right: 0;
  }

  @media only screen and (min-width: 664px) and (max-width: 1023px) {
    border-right: 1px solid ${({ theme }) => theme.elsie.colors.others.divider};
  }
  @media only screen and (min-width: 1320px) {
    border-right: 1px solid ${({ theme }) => theme.elsie.colors.others.divider};
  }
  @media only screen and (min-width: 1024px) and (max-width: 1319px) {
    border-bottom: 1px solid ${({ theme }) => theme.elsie.colors.others.divider};
    padding-bottom: 6px;
    padding-right: 0;
  }
`;

export const YearlyPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 33px;

  @media only screen and (max-width: 663px) {
    padding-left: 0;
    padding-top: 8px;
  }

  @media only screen and (min-width: 1024px) and (max-width: 1319px) {
    padding-left: 0;
    padding-top: 6px;
  }
`;

export const MonthlyPrice = styled.div`
  align-items: end;
  display: flex;
`;

export const YearlyPrice = styled.div`
  align-items: end;
  display: flex;
`;

export const PlansBannerSubtitle = styled.h4`
  font-size: 215px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: 0;
  margin: 0;
  @media only screen and (min-width: 1024px) {
    display: block;
    font-size: 24px;
  }
`;

export const PlansButton = styled.button`
  ${buttoBaseStyle};
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${({ theme }) => theme.elsie.borderWidth.sm} solid ${({ theme }) => theme.elsie.colors.border.subtle};
  background-color: ${({ theme }) => theme.elsie.colors.surface.faint.default};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.soft};
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  padding: 10px ${({ theme }) => theme.elsie.dimension[16]};
  font-size: 15px;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  @media only screen and (min-width: 1024px) {
    padding: 13px ${({ theme }) => theme.elsie.dimension[16]};
    font-size: 17px;
    border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  }
  @media only screen and (max-width: 1023px) {
    width: 100%;
    margin-top: 0;
  }

  @media only screen and (min-width: 1024px) {
    margin-top: 16px;
  }
  width: max-content;
`;

export const CheckoutButton = styled.button`
  ${buttoBaseStyle};
  width: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.default};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.accent};
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  padding: 10px ${({ theme }) => theme.elsie.dimension[16]};
  font-size: 15px;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  }
  &:active {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.pressed};
  }
  @media only screen and (min-width: 1024px) {
    padding: 13px ${({ theme }) => theme.elsie.dimension[16]};
    font-size: 17px;
    border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  }
  @media only screen and (max-width: 1023px) {
    margin-top: 0;
    width: 100%;
  }

  @media only screen and (min-width: 1024px) {
    margin-top: 16px;
  }
`;
